import { RootState } from "@/store/store";
import { ModuleTree } from "vuex";
import { accountActions } from "./account.actions";
import { accountMutations } from "./account.mutations";
import { accountState } from "./account.state";

export default {
    namespaced: true,
    state: accountState,
    actions: accountActions,
    mutations: accountMutations,
} as unknown as ModuleTree<RootState>;